module.exports = __webpack_public_path__ + "img/banner2.95b34826.png";